jQuery(document).ready(function ($) {

  const $popup = $('<dialog class="gallery-popup"><button class="gallery-popup__close" aria-label="Sluiten"></button><div class="gallery-popup__content"></div></dialog>').appendTo('body');
  //const $overlay = $('<div class="gallery-overlay" hidden>').appendTo('body');
  const $content = $popup.find('.gallery-popup__content');
  const dialog = $popup[0];
  let $activeFigure = null;
  let isOpen = false;

  function suppressAllFigures() {
    $('.row-media-collection__tile').each(function () {
      $(this).data('saved-transition-name', $(this).css('view-transition-name'));
      $(this).css('view-transition-name', 'none');
    });
  }

  function restoreAllFigures() {
    $('.row-media-collection__tile').each(function () {
      const saved = $(this).data('saved-transition-name');
      if (saved) {
        $(this).css('view-transition-name', saved);
        // Clear any transition name that may have been set on the img
        $(this).find('img').css('view-transition-name', '');
      }
    });
  }

  function openPopup($figure, src, isVideo, isShorts) {
    if (isOpen) return;
    isOpen = true;

    $activeFigure = $figure;

    suppressAllFigures();

    const $img = $figure.find('img').first();
    $img.css('view-transition-name', 'active-media');

    // Force browser to acknowledge the new transition name before starting
    requestAnimationFrame(() => {
      const launch = () => {
        $content.empty();
        $content.css('view-transition-name', '');
        $content.toggleClass('gallery-popup__content--shorts', !!isShorts);

        if (isVideo) {
          const videoId = src.replace('https://www.youtube.com/embed/', '');
          const $thumb = $('<div class="video-placeholder">').append(
            $('<img>', { src: `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` }),
            $('<button class="video-placeholder__play" aria-label="Afspelen">')
          ).appendTo($content);

          // Load iframe only on explicit user click
          $thumb.find('.video-placeholder__play').one('click', function () {
            $thumb.replaceWith($('<iframe>', {
              src: src + '?autoplay=1&rel=0',
              allow: 'autoplay; encrypted-media',
              allowfullscreen: true,
            }));
          });
        } else {
          $content.append($('<img>', { src: src }));
        }

        $content.find('img, iframe').css('view-transition-name', 'active-media');
        $img.css('view-transition-name', 'none');
        dialog.showModal();
      };

      document.documentElement.classList.add('gallery-opening');

      const transition = document.startViewTransition
        ? document.startViewTransition(launch)
        : { finished: Promise.resolve(launch()) };

      transition.finished.then(() => {
        document.documentElement.classList.remove('gallery-opening');
      });
    });
  }

  function closePopup() {
    if (!$activeFigure) return;

    const savedName = $activeFigure.data('saved-transition-name');

    const dismiss = () => {
      // Move name from popup content back to figure img
      $content.find('img, iframe').css('view-transition-name', 'none');
      $content.css('view-transition-name', '');

      const $img = $activeFigure.find('img').first();
      $img.css('view-transition-name', 'active-media');

      $content.find('iframe').attr('src', '');
      $content.empty();
      //$overlay.attr('hidden', true);
      dialog.close();
    };

    document.documentElement.classList.add('gallery-closing');

    const transition = document.startViewTransition
      ? document.startViewTransition(dismiss)
      : { finished: Promise.resolve(dismiss()) };

    transition.finished.then(() => {
      document.documentElement.classList.remove('gallery-closing');
      // Restore all figures only after transition completes
      $activeFigure.css('view-transition-name', savedName);
      restoreAllFigures();
      $activeFigure = null;
      isOpen = false;
    });
  }

  // YouTube - click on playback button
  $(document).on('click', '.playback', function (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    const $figure = $(this).closest('figure');
    const $embed = $figure.find('.video-embed');
    openPopup($figure, $embed.data('src'), true, $embed.is('[data-shorts]'));
  });

// YouTube - click on thumbnail image
  $(document).on('click', '.video-embed img', function (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    const $figure = $(this).closest('figure');
    const $embed = $figure.find('.video-embed');
    openPopup($figure, $embed.data('src'), true, $embed.is('[data-shorts]'));
  });

// Image only
  $(document).on('click', '.row-media-collection__tile--image img', function (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    const $figure = $(this).closest('figure');
    openPopup($figure, $(this).attr('src'), false);
  });

  // Close button
  $(document).on('click', '.gallery-popup__close', closePopup);

  $popup.on('click', function (e) {
    if (e.target === dialog) closePopup();
  });

  // Escape
  $popup.on('cancel', function (e) {
    e.preventDefault();
    closePopup();
  });

});